/* eslint-disable complexity */
/* eslint-disable no-new-func */
import i18n from '@baidu/bce-i18n';

const isConsoleOnline = location.host === 'console.bce.baidu.com';

const isLocal = location.origin.includes('local');

export const getBrowserLanguage = () => {
    let language = 'zh-cn';
    if (navigator.language || (navigator as any).userLanguage) {
        language = navigator.language || (navigator as any).userLanguage;
    }
    if (navigator.languages && navigator.languages[0]) {
        language = navigator.languages[0];
    }
    return language.toLowerCase();
};

export const getLanguage = () => {
    const language = window?.framework?.i18n?.getCurrentLanguage?.();
    if (language) {
        return language;
    }
    const queryLocale = /locale=([a-zA-Z-]+)/g.exec(location.search);
    return queryLocale?.[1] || getBrowserLanguage();
};

export const getDefaultLanguage = (): string => {
    return i18n.getContext()?.config?.defaultLanguage || getBrowserLanguage();
};

export const isZhCn = () => getLanguage() === 'zh-cn';

export const initI18n = async () => {
    try {
        const language = getLanguage();
        const url = isLocal ? 'https://bj.bcebos.com/v1/bce-cdn/console/static/i18n/console.offline.%s.json'
            : isConsoleOnline
                ? 'https://bce.bdstatic.com/console/static/i18n/console.%s.json'
                : 'https://bce.bdstatic.com/console/static/i18n/console.offline.%s.json';
        i18n.init({url});
        await i18n.activate(language);
    } catch {
        /* empty */
    }
};

export const i18nPunct = (punct: string, space?: boolean) => {
    if (isZhCn()) {
        return punct;
    }

    let enPunct = punct;
    switch (punct) {
        case '。':
            enPunct = '.';
            break;
        case '，':
            enPunct = ',';
            break;
        case '、':
            enPunct = ',';
            break;
        case '：':
            enPunct = ':';
            break;
        case '；':
            enPunct = ';';
            break;
        case '？':
            enPunct = '?';
            break;
        case '！':
            enPunct = '!';
            break;
        case '（':
            enPunct = '(';
            break;
        case '）':
            enPunct = ')';
            break;
        case '「':
        case '“ ':
            enPunct = '"';
            break;
        case '” ':
        case '」':
            enPunct = '"';
            break;
        case '《':
        case '》':
            enPunct = '';
            break;
        case '【':
            enPunct = '[';
            break;
        case '】':
            enPunct = ']';
            break;
    }
    if (space) {
        if (['（', '「', '“', '【', '《'].includes(punct)) {
            enPunct = ' ' + enPunct;
        }
        else {
            enPunct = enPunct + ' ';
        }
    }
    return enPunct;
};
